import FleetPreStartPage from "./index";
import DetailFleetStart from "./detail";

const router = {
  settings: {
    layout: {},
  },

  routes: [
    {
      path: "/fleet/prestarts/:id",
      component: DetailFleetStart,
      auth: ["admin", "manager"],
      settings: {
        layout: {
          head: true,
          sider: true,
        }
      }
    },
    {
      path: "/fleet/prestarts",
      component: FleetPreStartPage,
      auth: ["admin", "manager"],
      settings: {
        layout: {
          head: true,
          sider: true,
        }
      }
    },
  ],
};

export default router;
